import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function dateFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const regex = /^(19|20)\d{2}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
        if (!regex.test(value)) {
            return { 'invalidDate': true };
        }

        return null;
    };
}
